<ion-toolbar class="message-banner-bar">
    <ion-item slot="start" lines="none" color="warning-tint">
        <ion-label> Please complete your profile to search and apply. </ion-label>
    </ion-item>
</ion-toolbar>
